<template>
  <div :class="['puntata-button', {'selected' : isSelected}]" @click="clickBtn">
    <span v-text="number"></span>
  </div>
</template>
<script>
export default {
  props: ["content", "number", "puntataSelezionata"],
  data() {
    return {
      isSelected: false
    };
  },
  watch: {
    puntataSelezionata(p){
      if( p == this.number )
        this.isSelected = true
      else
        this.isSelected = false
    }
  },
  mounted() {
    if( this.puntataSelezionata == this.number )
      this.isSelected = true
    else
      this.isSelected = false
  },
  computed: {
  },
  methods: {
    clickBtn() {
      this.isSelected = true
      this.$emit('childToParent', this.number)
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/bootstrap-grid.scss";
@import "@/assets/scss/fonts.scss";
.puntata-button{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border: 2px solid $mdf-white;
  border-radius: 50%;
  cursor: pointer;
  &:hover{
    background-color: $mdf-white;
    span{
      color: $mdf-lightblue;
    }
  }
  span{
    color: $mdf-white;
    font-family: Montserrat;
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 1.5px;
    text-align: center;
    padding-left: 2px;
  }
}
.puntata-button.selected{
      background-color: $mdf-white;
        span{
          color: $mdf-darkblue;
        }
    }

/* Smartphones (portrait and landscape) ----------- */
@media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
  .puntata-button{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border: 1px solid $mdf-white;
    margin: 15px !important;
    span{
      font-size: 12px;
    }
  }
}
</style>
